import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export const ProductCard = ({ product }) => {
  const collectionStyles = {
    astro: "bg-accent-blue",
    drinks: "bg-accent-pink text-white",
    quotes: "bg-accent-yellow",
    handmade: "bg-accent-green",
  };

  const categoryLabels = {
    magliette: "T-Shirt",
    felpe: "Felpa",
    homemade: "Homemade",
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ y: -8 }}
      className="group"
      data-testid={`product-card-${product.product_id}`}
    >
      <Link to={`/prodotto/${product.product_id}`}>
        <div className="card-brutal relative overflow-hidden">
          {/* Image */}
          <div className="aspect-square overflow-hidden bg-gray-100 border-b-2 border-black">
            <img
              src={product.image_url}
              alt={product.name}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
            />
          </div>

          {/* Collection Badge */}
          <div className="absolute top-4 left-4">
            <span
              className={`font-mono text-xs uppercase px-3 py-1 border-2 border-black ${collectionStyles[product.collection] || "bg-white"}`}
            >
              {product.collection}
            </span>
          </div>

          {/* Info */}
          <div className="p-4">
            <h3 className="font-heading text-xl mb-2 group-hover:text-accent-pink">
              {product.name}
            </h3>
            <p className="font-body text-sm text-gray-600 mb-3 line-clamp-2">
              {product.description}
            </p>
            <div className="flex justify-between items-center">
              <span className="font-mono text-xl font-bold">
                €{product.price.toFixed(2)}
              </span>
              <span className="font-body text-sm uppercase text-gray-500">
                {categoryLabels[product.category] || product.category}
              </span>
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
